export default "__VITE_ASSET__CxIawWVe__"